import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetComparePatentRepository } from '../claim-charting-repository';
import type { PatentItemInfo } from '../../types';
import type { AddComparePatentService } from '../add-compare-patent-service';
import { COMPARE_PATENT_LATEST_DATA } from '../../constants';
import { IndexDBService } from '../index-data-base-service';
@injectable()
export class AddComparePatentServiceImpl implements AddComparePatentService {
    @inject(IndexDBService)
    private _indexDBService!: IndexDBService<PatentItemInfo[]>;
    @inject(GetComparePatentRepository)
    private _getComparePatentRepository!: GetComparePatentRepository;


    // 精确查询对比patentInfo
    public getComparePatent(q: string) {
        return this._getComparePatentRepository.getComparePatent(q);
    }

    // 本地存储对比patent数据,去重，只存最近10条
    public async saveLocalComparePatent(params: PatentItemInfo) {
        const data = await this._indexDBService.getData(COMPARE_PATENT_LATEST_DATA) || [];
        const uniqueData = data.filter(item => item.PATENT_ID !== params.PATENT_ID);
        uniqueData.unshift(params);
        const latestData = uniqueData.slice(0, 10);
        return this._indexDBService.saveData(COMPARE_PATENT_LATEST_DATA, latestData);
    }

    // 获取本地存储对比patent数据
    public getLocalComparePatent() {
        return this._indexDBService.getData(COMPARE_PATENT_LATEST_DATA) || [];
    }
}